export default __webpack_public_path__ + "static/06-6cbe5f13fd4869e1566a1b93d87b6501.jpg";